/* eslint-disable no-debugger */
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import { getABOnline } from '@common/utils/newABtest';
import { curEnv } from '@common/utils/env';
import { Decimal } from 'decimal.js';

const AYH_PUBLIC_DATA = window.AYH_PUBLIC_DATA || {};
//rsa公钥
const SK_PUBLIC_KEY =
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0pfkXa+iGOHLNDCy/7teDUxNADcZDiMG1BZZCiW9pNGRbc0ixBKXc/XXlUdgyCAsrS4S3uVbM22hcPrUy39ZvKJY6RFTt5nDW3lVNkhQaf28YXpSp6zZKARfF9wbSnVqnZnYk27GkI12ISD04ZOC5mqt0G60hyxnXo+35lXOCgCMwmDiy9Xfpn18roMLOdTzjydNzUvxWfY9T85ZrWep7FV5xRemP8KbWFem47kz6gEMYr/LLX3VuEjiOY2klP9+EMSLRz4Ej5zbnUC9+NHZZ07YIStuFVZbwc1T7O/5XReHw3r6kdCo4qoJTj01DM1RRq9GDKt8/is+6k8lSAnKTQIDAQAB';

const randomStr = (len, charSetStr) => {
  let charSet = charSetStr || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < len; i++) {
    let randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
};

const aesNow = () => {
  //当前时间
  function getNow(s) {
    return s < 10 ? '0' + s : s;
  }
  let myDate = new Date();
  let year = myDate.getFullYear(); //获取当前年
  let month = myDate.getMonth() + 1; //获取当前月
  let date = myDate.getDate(); //获取当前日
  let h = myDate.getHours(); //获取当前小时数(0-23)
  let m = myDate.getMinutes(); //获取当前分钟数(0-59)
  let s = myDate.getSeconds();
  let getTimeNoSecond = '' + year + getNow(month) + getNow(date) + getNow(h) + getNow(m);
  getTimeNoSecond = 'msxf' + getTimeNoSecond.slice(0, -1) + '0';
  let getTimeHasSecond =
    year +
    '-' +
    getNow(month) +
    '-' +
    getNow(date) +
    ' ' +
    getNow(h) +
    ':' +
    getNow(m) +
    ':' +
    getNow(s);
  AYH_PUBLIC_DATA._aesEncryTime = getTimeHasSecond; //aes加密传输时间
  AYH_PUBLIC_DATA._getTimeNoSecond = getTimeNoSecond; //aes本地加密时间
  AYH_PUBLIC_DATA._sktrans = randomStr(16);
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(
    '-----BEGIN RSA PRIVATE KEY-----' + SK_PUBLIC_KEY + '-----END RSA PRIVATE KEY-----',
  );
  let encrypted = encrypt.encrypt(AYH_PUBLIC_DATA._sktrans);
  AYH_PUBLIC_DATA._encrysktrans = encrypted;
  window.AYH_PUBLIC_DATA = AYH_PUBLIC_DATA;
};

/*
 *@description aes加密
 *1)str 要加密的字符串
 *2)time 加密时间
 */

const aesEncry = (str) => {
  //aes加密
  let encrypt = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(str ?? ''),
    CryptoJS.enc.Utf8.parse(AYH_PUBLIC_DATA._sktrans),
    {
      iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );
  return encrypt.toString();
};
/*
 *@description 接口请求数据整体加密
 *1)data 请求参数
 */
const wholeEncryParams = (config) => {
  if (typeof JSEncrypt === 'undefined') {
    return null;
  }
  if (config?.data) {
    config.data.antiReplaying = randomStr(32) + '_' + new Date().getTime();
  }
  const sktrans = randomStr(16);
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(
    `-----BEGIN RSA PRIVATE KEY-----${SK_PUBLIC_KEY}-----END RSA PRIVATE KEY-----`,
  );
  console.log('这里是 加密前的参数 的结果-------------', config.data);
  const encrypted = encrypt.encrypt(sktrans);
  const encryptStr = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(JSON.stringify(config.data)),
    CryptoJS.enc.Utf8.parse(sktrans),
    {
      iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );
  window.tempSktrans = sktrans;
  config.encryStr = sktrans;
  config.encrysktrans = encrypted;
  // 给全局赋值
  AYH_PUBLIC_DATA._encrysktrans = encrypted;
  AYH_PUBLIC_DATA._sktrans = sktrans;
  AYH_PUBLIC_DATA.encryStr = sktrans;
  window.AYH_PUBLIC_DATA = AYH_PUBLIC_DATA;
  return encryptStr.toString();
};

//  /*
//      *@description aes整体解密
//      *1)str aes加密之后的字符串
//      *2)time 加密时间
//      */

const wholeAesDecip = (str, key) => {
  //aes解密
  const decKey = key;
  const decrypt = CryptoJS.AES.decrypt(str ?? '', CryptoJS.enc.Utf8.parse(decKey), {
    iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

/**
 *
 * @returns 当前时间
 */
const getdate = () => {
  var now = new Date(),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  return '' + y + m + d;
};

/*
 *@description aes加密
 *1)str aes加密之后的字符串
 *2)time 加密时间
 */

const aesDecip = (str) => {
  //aes解密
  let decrypt = CryptoJS.AES.decrypt(str ?? '', CryptoJS.enc.Utf8.parse(AYH_PUBLIC_DATA._sktrans), {
    iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

/*
 *@description aes加密
 *1)str aes加密之后的字符串
 *2)time 加密时间
 */

const parseTimeDe = (str) => {
  //aes解密
  return 'msxf' + str.replace(/\D/g, '').slice(0, -3) + '0';
};

/*
 *@description 交易密码逐字符加密
 *1)str 加密内容
 */
const transPwdAesEncry = (str) => {
  let num = 0;
  if (AYH_PUBLIC_DATA._transPwdIsTwo) {
    num = 1;
  }
  console.log('加密前字符串', str);
  if (!AYH_PUBLIC_DATA._transPwdAes) {
    AYH_PUBLIC_DATA._transPwdAes = randomStr(32);
  }
  if (!AYH_PUBLIC_DATA._transPwdAesArr) {
    AYH_PUBLIC_DATA._transPwdAesArr = [[], []];
  }
  console.log('加密前数组', AYH_PUBLIC_DATA._transPwdAesArr);

  if (str.length < AYH_PUBLIC_DATA._transPwdAesArr[num].length) {
    //用户删除
    AYH_PUBLIC_DATA._transPwdAesArr[num].pop();
    return str;
  }

  let pwd = str.replace(/\D/g, '');
  console.log('要加密的密码', pwd);
  if (str.length == '1' && pwd.length == 1 && !AYH_PUBLIC_DATA._transPwdIsTwo)
    AYH_PUBLIC_DATA._transPwdAesArr = [[], []]; //如果用户重新输入，则重置加密数组
  if (pwd != '') {
    encryFun(pwd);
  }

  function encryFun(data) {
    let encryptStr = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(data),
      CryptoJS.enc.Utf8.parse(AYH_PUBLIC_DATA._transPwdAes),
      {
        iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    AYH_PUBLIC_DATA._transPwdAesArr[num].push(encryptStr.toString());
  }
  console.log('加密后数组', AYH_PUBLIC_DATA._transPwdAesArr);
  return str.replace(/\d/g, '*');
};

/*
 *@description 交易密码逐字符解密
 */
const transPwdAesDecip = (pwdNo) => {
  let pwd = '';
  let num = Number(pwdNo) || 0;
  if (AYH_PUBLIC_DATA._transPwdIsTwo) {
    num = 1;
  }
  AYH_PUBLIC_DATA._transPwdAesArr[num].forEach((item, index) => {
    console.log(item, index);
    let decrypt = CryptoJS.AES.decrypt(
      item,
      CryptoJS.enc.Utf8.parse(AYH_PUBLIC_DATA._transPwdAes),
      {
        iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    console.log(pwd);
    pwd += CryptoJS.enc.Utf8.stringify(decrypt).toString();
  });
  console.log(pwd);
  return pwd;
};

/*
 *@description 通用密码逐字符加密
 *1)str 要加密的字符（单个）
 *2)strArr 存储字符加密后内容的数组
 *3)transPwdAesRandom 加密/解密串
 */
const allPwdAesEncry = (str = '', strArr = [], transPwdAesRandom = '') => {
  console.log('加密前数组', strArr);
  console.log('要加密的密码', str);
  let newStrArr = [];
  newStrArr = newStrArr.concat(strArr);
  if (str !== ' ') {
    encryFun(str);
  }

  function encryFun(str) {
    let encryptStr = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(str),
      CryptoJS.enc.Utf8.parse(transPwdAesRandom),
      {
        iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    newStrArr.push(encryptStr.toString());
  }
  console.log('加密前数组', strArr);
  console.log('加密后数组', newStrArr);
  return newStrArr;
};

/*
 *@description 通用密码逐字符解密
 *1)strArr 存储字符加密后内容的数组
 *2)transPwdAesRandom 加密/解密串
 */
const allPwdAesDecip = (strArr = [], transPwdAesRandom = '') => {
  let pwd = '';
  strArr.forEach((item, index) => {
    let decrypt = CryptoJS.AES.decrypt(item, CryptoJS.enc.Utf8.parse(transPwdAesRandom), {
      iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    pwd += CryptoJS.enc.Utf8.stringify(decrypt).toString();
  });
  console.log(pwd);
  return pwd;
};

const AES = {
  aesNow,
  aesEncry,
  aesDecip,
  parseTimeDe,
  transPwdAesEncry,
  transPwdAesDecip,
  allPwdAesEncry,
  allPwdAesDecip,
  wholeEncryParams,
  wholeAesDecip,
};

const debounce = (fn, de) => {
  let timer = null;
  let delay = de || 200;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this);
    }, delay);
  };
};

const encodeName = (zhName) => {
  let len = zhName.length;
  let startNum, endNum;
  if (len == 2) {
    startNum = 0;
    endNum = 1;
  } else if (len == 4) {
    startNum = 2;
    endNum = 1;
  } else {
    startNum = 0;
    endNum = 1;
  }
  return zhName.replace(/./g, function (match, index) {
    return index < startNum || index >= len - endNum ? match : '*';
  });
};
const encodSurname = (zhName) => {
  let len = zhName.length;
  let startNum = 1;
  if (len < 2) {
    return zhName;
  }
  return zhName.replace(/./g, function (match, index) {
    return index >= startNum ? '*' : match;
  });
};
const encodePhone = (phoneNumber) => {
  let len = phoneNumber.length,
    tempMask;
  let mask = '****';
  return phoneNumber.replace(/./g, function (match, index) {
    return index < 3 || index >= len - 4 ? match : ((tempMask = mask), (mask = ''), tempMask);
  });
};

const maskPhone = (phoneNumber) => {
  if (!phoneNumber) {
    return '';
  }
  // 确保电话号码是字符串类型
  const phoneStr = phoneNumber.toString();
  // 获取后三位
  const lastThreeDigits = phoneStr.slice(-3);
  // 构建掩码后的电话号码
  const maskedPhone = '*'.repeat(phoneStr.length - 3) + lastThreeDigits;
  return maskedPhone;
};

/**
 *@description 身份证号脱敏
 *字符串中间部分变成*，默认保留前6位和后4位
 */
const encodeIdCard = (str, startNum, endNum) => {
  let len = str.length;
  startNum = startNum === undefined ? 6 : startNum;
  endNum = endNum === undefined ? 4 : endNum;
  return str.replace(/./g, function (match, index) {
    return index < startNum || index >= len - endNum ? match : '*';
  });
};

/**
 * 是否为空
 * @param obj
 * @returns {boolean}
 */
let isEmpty = (obj) => {
  return obj == null || obj === '';
};

/**
 * 是否不为空
 * @param obj
 * @returns {boolean}
 */
let isNotEmpty = (obj) => {
  return !isEmpty(obj);
};

/**
 * 验证码规则校验
 * @param value
 * @returns {boolean}
 */
let smsCode = (value) => {
  if (isEmpty(value)) return true;
  return /^[\d]{4,8}$/.test(value);
};

/**
 * 名字校验规则
 * @param name
 * @returns {boolean}
 */

const checkZhName = (name, checkStar = false) => {
  if (name == undefined || name == null || name == '') {
    return false;
  } else if (checkStar && /\*/.test(name)) {
    return false;
  } else if (/[\u4E00-\u9FA5]/.test(name) && name.length > 1) {
    console.log('中文姓名校验通过');
    return true;
  } else {
    return false;
  }
};

/**
 * 手机号规则
 * @param phone
 * @returns {boolean}
 */

const checkPhone = (phone, checkStar = false) => {
  if (phone == undefined || phone == null || phone == '') {
    return false;
  } else if (checkStar && /\*/.test(phone)) {
    return false;
  } else if (/(^[1][0-9]{10}$)/.test(phone)) {
    console.log('手机号校验通过');
    return true;
  } else {
    return false;
  }
};

// 校验银行卡，前置判空，位数，字符等校验业务逻辑里给予dialog提示
// 此处不提供UI反馈
const checkBankID = (bankId = '', strict) => {
  let bankNumber = bankId.replace(/\s/g, '');
  let strBin =
    '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99';
  if (
    bankNumber == undefined ||
    bankNumber == null ||
    bankNumber == '' ||
    bankNumber.length < 16 ||
    bankNumber.length > 19 ||
    !/^\d*$/.exec(bankNumber) ||
    strBin.indexOf(bankNumber.substring(0, 2)) == -1
  ) {
    return false;
  } else {
    if (!strict) {
      console.log('测试环境银行卡不强校验通过');
      return true;
    }
    let lastNum = bankNumber.substr(bankNumber.length - 1, 1); //取出最后一位（与luhn进行比较）
    let first15Num = bankNumber.substr(0, bankNumber.length - 1); //前15或18位
    let newArr = [];
    for (let i = first15Num.length - 1; i > -1; i--) {
      //前15或18位倒序存进数组
      newArr.push(first15Num.substr(i, 1));
    }
    let arrJiShu = []; //奇数位*2的积 <9
    let arrJiShu2 = []; //奇数位*2的积 >9
    let arrOuShu = []; //偶数位数组
    for (let j = 0; j < newArr.length; j++) {
      if ((j + 1) % 2 == 1) {
        //奇数位
        if (parseInt(newArr[j]) * 2 < 9) {
          arrJiShu.push(parseInt(newArr[j]) * 2);
        } else {
          arrJiShu2.push(parseInt(newArr[j]) * 2);
        }
      } else {
        arrOuShu.push(newArr[j]);
      }
    }

    let jishu_child1 = []; //奇数位*2 >9 的分割之后的数组个位数
    let jishu_child2 = []; //奇数位*2 >9 的分割之后的数组十位数
    for (let h = 0; h < arrJiShu2.length; h++) {
      jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
      jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
    }

    let sumJiShu = 0; //奇数位*2 < 9 的数组之和
    let sumOuShu = 0; //偶数位数组之和
    let sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
    let sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
    let sumTotal = 0;
    for (let m = 0; m < arrJiShu.length; m++) {
      sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
    }

    for (let n = 0; n < arrOuShu.length; n++) {
      sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
    }

    for (let p = 0; p < jishu_child1.length; p++) {
      sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
      sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
    }
    //计算总和
    sumTotal =
      parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

    //计算luhn值
    let k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
    let luhn = 10 - k;

    if (lastNum == luhn) {
      console.log('银行卡校验通过');
      return true;
    } else {
      console.log('银行卡校验失败');
      return false;
    }
  }
};

/**
 * 身份证规则
 * @param obj
 * @returns {boolean|number}
 */
const checkIDNumber = (value, checkStar = false) => {
  if (value == undefined || value == null || value == '') {
    return false;
  } else if (checkStar && /\*/.test(value)) {
    return false;
  } else {
    let myDate = new Date();
    let year = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
    let month = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    let day = myDate.getDate(); //获取当前日(1-31)
    let reg18 = /(^\d{17}([0-9]|X|x)$)/;
    let reg15 = /(^\d{15}$)/;
    let flag = false;
    let sdata = value.substr(6, 8);
    let data1 = year + '' + (month < 10 ? '0' + month : month) + '' + (day < 10 ? '0' + day : day);
    if (data1 - sdata <= 180000) {
      console.log('[error]:当前时间');
      flag = 18;
    } else if (reg18.test(value)) {
      let y = value.substr(6, 4);
      let m = value.substr(10, 2);
      let d = value.substr(12, 2);
      try {
        y = Number(y);
        m = Number(m);
        d = Number(d);
        if (y > 1902 && y < new Date().getFullYear() && m < 13 && m > 0 && d < 32 && d > 0) {
          // 省份证验证真伪因素
          const FACTOR = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          // 最后一位生成规则
          const LAST = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
          // 计算前17位身份证号关联因子对应的和
          let sum = 0;
          FACTOR.forEach((factor, i) => {
            sum += factor * parseInt(value.charAt(i));
          });
          // 求最后一位对应序号
          let mod = sum % LAST.length;
          let last = LAST[mod];
          let _last = value.charAt(FACTOR.length);
          if (_last == 'x') _last = 'X';
          flag = last == _last;
        }
      } catch (e) {
        console.log('[error]:18位身份证不合法');
        flag = false;
      }
    } else if (reg15.test(value)) {
      const city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 ',
      };
      if (city[value.substr(0, 2)]) {
        let y = '19' + value.substr(6, 2);
        let m = value.substr(8, 2);
        let d = value.substr(10, 2);
        try {
          y = Number(y);
          m = Number(m);
          d = Number(d);
          if (y > 1949 && y < 2000 && m < 13 && d < 32) {
            flag = true;
          }
        } catch (e) {
          console.log('[error]:15位身份证不合法');
          flag = false;
        }
      } else {
        return false;
      }
    }
    return flag;
  }
};

// 简易校验银行卡号
const checkBankIdSimple = (value = '') => {
  return /^[\d]{14,19}$/.test(value);
};

// 校验登录密码强度 弱 中 强
//入参：登录密码 value
const checkLoginPwd = (value) => {
  let passwordLevel = {
    //登录密码至少8位，数字、字母混合。符合密码基本规则者为70分
    isQualified: function (value) {
      let qualifiedReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;
      return qualifiedReg.test(value);
    },
    //找出密码中大写字母和小写字母分别出现的次数
    calculateCount: function (value) {
      let upCount = 0;
      let lowCount = 0;
      let otherCount = 0;
      for (let i = 0; i < value.length; i++) {
        let c = value.charAt(i);
        if (c >= 'a' && c <= 'z') {
          lowCount++;
        } else if (c >= 'A' && c <= 'Z') {
          upCount++;
        } else {
          otherCount++;
        }
      }
      return {
        upCount: upCount,
        lowCount: lowCount,
        otherCount: otherCount,
        validCount: upCount + lowCount,
      };
    },
    //找出重复的字符，返回一个数组
    repeatCount: function (value) {
      let reg = /([0-9a-zA-Z])\1{1,}/g;
      return value.match(reg);
    },
    //找出连续出现的数字
    numberCount: function (value) {
      let numReg = /\d{4,}/g;
      return value.match(numReg);
    },
    //找出连续出现的字母
    letterCount: function (value) {
      let letterReg = /[a-zA-Z]{4,}/g;
      return value.match(letterReg);
    },
    //同类型字符3个及3个以上为连续，需要找出连续（包括顺序连续和倒序连续）的个数
    serialTypeCount: function (value) {
      //边界条件的处理
      value += ' ';
      let f = value.charCodeAt(0);
      let arr = [];
      let count = 0;
      for (let i = 1; i < value.length; ++i) {
        let c = value.charCodeAt(i);
        if (c - f == 1 || f - c == 1) {
          ++count;
        } else {
          if (count >= 2) {
            arr.push(value.substring(i - count - 1, i));
          }
          count = 0;
        }
        f = c;
      }
      return arr;
    },
  };
  let score;
  if (passwordLevel.isQualified(value)) {
    score = 70 + (value.length - 8) * 4;
    let calculateCountResult = passwordLevel.calculateCount(value);
    let plusScore =
      (calculateCountResult['validCount'] - calculateCountResult['upCount']) *
      (calculateCountResult['validCount'] - calculateCountResult['lowCount']) *
      2;
    score += plusScore;
    if (passwordLevel.repeatCount(value) != null) {
      passwordLevel.repeatCount(value).forEach(function (item, index) {
        score -= item.length * 2;
      });
    }
    if (passwordLevel.numberCount(value) != null) {
      passwordLevel.numberCount(value).forEach(function (item, index) {
        score -= (item.length - 3) * 1;
      });
    }
    if (passwordLevel.letterCount(value) != null) {
      passwordLevel.letterCount(value).forEach(function (item, index) {
        score -= (item.length - 3) * 1;
      });
    }
    score -= passwordLevel.serialTypeCount(value).length * 3;
    if (score < 60) {
      return '弱';
    } else if (score < 80 && score >= 60) {
      return '中';
    } else if (score >= 80) {
      return '强';
    }
  } else {
    return false;
  }
};

/**
 * 登录密码校验
 * @param obj
 * @returns {boolean}
 */
const checkSafeLoginPwd = (value = '') => {
  if (value.length < 8 || value.length > 16) return false;
  return (/[a-z]/.test(value) || /[A-Z]/.test(value)) && /[0-9]/.test(value);
  //return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value);
};

const filterProtocol = (html = '') => {
  let _html = '';
  _html = html.replace(/<style(([\s\S])*?)<\/style>/g, '');
  _html = _html.replace(/<meta(([\s\S])*?)>/g, '');
  return '<div class="protocol-header"></div>' + _html;
};

const getUrlKey = (name) => {
  // eslint-disable-next-line no-sparse-arrays
  return (
    decodeURIComponent(
      // eslint-disable-next-line no-sparse-arrays
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
        ,
        '',
      ])[1].replace(/\+/g, '%20'),
    ) || null
  );
};

/**
 * cbc解密
 * @param {*} str
 * @returns
 */
const cbcAesDecip = (str) => {
  //aes解密
  let decrypt = CryptoJS.AES.decrypt(str ?? '', CryptoJS.enc.Utf8.parse('msxfMsjr@msjrapi'), {
    iv: CryptoJS.enc.Utf8.parse('msxf@@@@@msjrapi'),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

const getUrlToJson = (urlSearch) => {
  let obj = {},
    index = urlSearch.indexOf('?'),
    params = '';
  if (index != -1) {
    params = urlSearch.substr(index + 1);
  } else {
    params = urlSearch;
  }
  if (params) {
    let parr = params.split('&');
    for (let i of parr) {
      let arr = i.split('=');
      obj[arr[0]] = arr[1];
    }
  }
  return obj;
};

// 普通加密
const compile = (code) => {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
};
// 普通解密
const uncompile = (code) => {
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
};

// 未发现有使用痕迹
// const getAndroidVersion = () => {
//   try {
//     var ua = navigator.userAgent || navigator.vendor || window.opera || '';
//     if (/android/i.test(ua)) {
//       var test = /android\s([\w]+)/i;
//       var match = ua.match(test);
//       console.log(match);
//       var version = match[1];
//       return version;
//     }
//     return false;
//   } catch {
//     return 6;
//   }
// };

/**
 * 数字转换为汉字
 * @param num 数字
 */
const numToChina = (num) => {
  var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  var arr2 = [
    '',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
  ]; //可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return '零';
  }
  var english = num.toString().split('');
  var result = '';
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i;
    result = arr2[i] + result;
    var arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
  result = result.replace(/零+/g, '零');
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
  result = result.replace(/亿万/g, '亿');
  result = result.replace(/零+$/, '');
  result = result.replace(/^一十/g, '十');
  return result;
};
let aliAppVersion = '';
let IS_ALIFACE_CLIENT = (function () {
  /**
   * 递归判断版本号
   * @param {*} minVersions  比较目标版本号
   * @param {*} apVersions    当前客户端版本号
   * @returns
   */
  function checkVersion(minVersions, apVersions) {
    if (apVersions.length > 0 && minVersions.length > 0) {
      if (apVersions[0] < minVersions[0]) {
        return false;
      } else if (minVersions.length === 1 || apVersions[0] > minVersions[0]) {
        return true;
      } else {
        return checkVersion(minVersions.slice(1), apVersions.slice(1));
      }
    }
    return false;
  }
  // 支付宝活体要求的支付宝最低版本
  var minApVersion = '10.2.12';
  // 从userAgent中获取支付宝版本号
  var matchResult = window.navigator.userAgent.match(/AliApp\(AP\/([\d\\.]+)\)/i); // 如: 10.1.58.00000170
  // 是否为支付宝客户端
  if (matchResult) {
    aliAppVersion = matchResult[1];
    return checkVersion(minApVersion.split('.').map(Number), aliAppVersion.split('.').map(Number));
  }
  return false;
})();

// 是否是自营产品
const isAyhSelfProductCode = (productCode) => {
  let productCodeS = ['5105', '5110', '5111', '5112'];
  return productCodeS.includes(productCode);
};

const clientType = (() => {
  let ua = navigator.userAgent || navigator.vendor || window.opera;
  // 判断客户端版本
  return {
    trident: /(Trident)/i.test(ua), // IE内核
    presto: /(Presto)/i.test(ua), // opera内核
    webKit: /(AppleWebKit)/i.test(ua), // google内核
    gecko: /(Trident)/i.test(ua), // 火狐内核
    ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    android: /(Android|Linux)/i.test(ua),
    iPhone: /(iPhone|Mac)/i.test(ua),
    iPad: /(iPad)/i.test(ua),
    wechat: /(MicroMessenger)/i.test(ua),
    qq: /(QQ)/i.test(ua),
    pc: !/(Android|iPhone|iPod|iOS|SymbianOS|Windows Phone)/i.test(ua),
    mobile: /mobile|tablet|ip(ad|hone|od)|android/i.test(ua),
    alipay: /AlipayClient/.test(ua),
  };
})();

function alipayJSBridgeReady(callback) {
  // 如果jsbridge已经注入则直接调用
  if (window.AlipayJSBridge) {
    callback && callback();
  } else {
    // 如果没有注入则监听注入的事件
    document.addEventListener('AlipayJSBridgeReady', callback, false);
  }
}

// 利用img发送请求，忽略response
function justRequest(url) {
  var img = new Image();
  // 忽略异常
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  img.onerror = function () {};
  // 发送请求
  img.src = url;
}

function isTqV2(res, slotCode) {
  return res && slotCode && res?.ads?.[slotCode]?.adDetails?.length;
}

function formatFirstIndexAdpData(result, params) {
  let formatData = {};
  if (isTqV2(result, params.slotCode)) {
    formatData = result?.ads?.[params.slotCode]?.adDetails?.[0];
  } else {
    if (result?.[params.adGroupCode]?.tqAdInfoList?.[0]?.adElementList?.length) {
      formatData = result?.[params.adGroupCode]?.tqAdInfoList?.[0];
      let templateContents = [];
      result?.[params.adGroupCode]?.tqAdInfoList?.[0]?.adElementList.forEach((item) => {
        if (item.elementType === 'text') {
          templateContents.push({
            txtContent: item.value,
          });
        } else if (item.elementType === 'image') {
          templateContents.push({
            imgUrl: item.value,
          });
        }
      });
      formatData.templateContents = JSON.parse(JSON.stringify(templateContents));
    }
  }
  return formatData;
}

function formatAdpAllData(result, params, needSingleData = false) {
  let formatData = [];
  if (isTqV2(result, params.slotCode)) {
    formatData = result.ads[params.slotCode].adDetails;
  } else if (result?.[params.adGroupCode]?.tqAdInfoList?.length) {
    formatData = result[params.adGroupCode].tqAdInfoList;
    formatData.forEach((item) => {
      if (item.eventValue) {
        item.adElementList[0].linkValue = item.eventValue;
      }
      item.templateContents = item.adElementList;
      item.templateContents.forEach((item) => {
        item.type = item.elementType;
        if (item.elementType === 'text') {
          item.txtContent = item.value;
        } else if (item.elementType === 'image') {
          item.imgUrl = item.value;
        }
      });
    });
  }
  if (needSingleData) {
    return formatData?.length ? formatData[0] : null;
  }
  return formatData;
}

// JSON格式转换判断
const isJsonString = (str) => {
  if (typeof str == 'string') {
    let obj;
    try {
      obj = JSON.parse(str);
      if (typeof obj == 'object' && obj) {
        return obj;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
  return null;
};

const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';

// 对象深度合并
const deepMerge = (target, source) => {
  if (isObject(target) && isObject(source)) {
    // 遍历源对象，将源对象存在但目标对象不存在的属性赋值给目标对象
    for (const key in source) {
      if (!Object.prototype.hasOwnProperty.call(target, key)) {
        target[key] = source[key];
      }
      // if (!target.hasOwnProperty(key)) {
      //   target[key] = source[key];
      // }
    }
    // 遍历目标对象
    for (const key in target) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        // 判断属性值数据类型，若不是对象类型则赋值给目标对象
        if (!isObject(source[key])) {
          target[key] = source[key];
        } else {
          // 是对象类型则递归调用
          deepMerge(target[key], source[key]);
        }
      }
    }
  }
};

// 获取时间
const getCurrentDate = function () {
  const myDate = new Date();
  const year = myDate.getFullYear(); //获取当前年
  const month = myDate.getMonth() + 1; //获取当前月
  const date = myDate.getDate();
  const yearMonth = `${year}-${month < 10 ? '0' + month : month}`;

  const nextMonth = month + 1 > 12 ? 1 : month + 1;
  const _nextMonth = nextMonth < 10 ? '0' + nextMonth : nextMonth;
  const nextYearMonth = month + 1 > 12 ? `${year + 1}-${_nextMonth}` : `${year}-${_nextMonth}`;

  const today = `${year}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`;
  const currentTime = new Date(today).getTime();

  return {
    today,
    month,
    nextMonth,
    yearMonth,
    nextYearMonth,
    currentTime,
  };
};

var CommonUtil = {
  /*
   *@description 获取当前时间
   *1)hasSecond 是否含秒  0 不含   1：含*
   */
  aesNow: function () {
    function getNow(s) {
      return s < 10 ? '0' + s : s;
    }
    let myDate = new Date();
    let year = myDate.getFullYear(); //获取当前年
    let month = myDate.getMonth() + 1; //获取当前月
    let date = myDate.getDate(); //获取当前日
    let h = myDate.getHours(); //获取当前小时数(0-23)
    let m = myDate.getMinutes(); //获取当前分钟数(0-59)
    let s = myDate.getSeconds();
    let getTimeNoSecond = '' + year + getNow(month) + getNow(date) + getNow(h) + getNow(m);
    getTimeNoSecond = 'msxf' + getTimeNoSecond.slice(0, -1) + '0';
    let getTimeHasSecond =
      year +
      '-' +
      getNow(month) +
      '-' +
      getNow(date) +
      ' ' +
      getNow(h) +
      ':' +
      getNow(m) +
      ':' +
      getNow(s);
    AYH_PUBLIC_DATA._aesEncryTime = getTimeHasSecond; //aes加密传输时间
    AYH_PUBLIC_DATA._getTimeNoSecond = getTimeNoSecond; //aes本地加密时间
    AYH_PUBLIC_DATA._sktrans = randomStr(16);
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(
      '-----BEGIN RSA PRIVATE KEY-----' + SK_PUBLIC_KEY + '-----END RSA PRIVATE KEY-----',
    );
    let encrypted = encrypt.encrypt(AYH_PUBLIC_DATA._sktrans);
    AYH_PUBLIC_DATA._encrysktrans = encrypted;
    window.AYH_PUBLIC_DATA = AYH_PUBLIC_DATA;
  },

  /*
   *@description aes加密
   *1)str 要加密的字符串
   *2)time 加密时间
   */

  aesEncry: function (str, _sktrans) {
    //aes加密
    var encrypt = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(str),
      CryptoJS.enc.Utf8.parse(_sktrans || window._sktrans),
      {
        iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    );
    return encrypt.toString();
  },

  /*
   *@description aes加密
   *1)str aes加密之后的字符串
   *2)time 加密时间
   */

  aesDecip: function (str) {
    //aes解密
    var decrypt = CryptoJS.AES.decrypt(str, CryptoJS.enc.Utf8.parse(window._sktrans), {
      iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },

  /*
   *@description aes加密
   *1)str aes加密之后的字符串
   *2)time 加密时间
   */

  parseTimeDe: function (str) {
    //aes解密
    return 'msxf' + str.replace(/\D/g, '').slice(0, -3) + '0';
  },
  /*
   *@description 用户姓名脱敏
   *1)姓名为两个字时第一个字变成*
   *2)姓名为四个字时第三个字变成*
   *3)姓名为三个字时或者多个字时只保留首位两个字符
   */
  encodeName: function (str) {
    var len = str.length,
      startNum,
      endNum;
    if (len == 2) {
      startNum = 0;
      endNum = 1;
    } else if (len == 4) {
      startNum = 2;
      endNum = 1;
    } else {
      startNum = 1;
      endNum = 1;
    }
    return str.replace(/./g, function (match, index) {
      return index < startNum || index >= len - endNum ? match : '*';
    });
  },
  /*
   *@description 身份证号脱敏
   *字符串中间部分变成*，默认保留前6位和后4位
   */
  encodeIdCard: function (str, startNum, endNum) {
    var len = str.length;
    startNum = startNum === undefined ? 6 : startNum;
    endNum = endNum === undefined ? 4 : endNum;
    return str.replace(/./g, function (match, index) {
      return index < startNum || index >= len - endNum ? match : '*';
    });
  },
  /*
   *@description 手机号脱敏
   *字符串中间部分变成*或指定的符号，默认保留前3位和后4位，字符长度不够时优先保留后面的字符
   */
  encodePhone: function (str, startNum, endNum, mask) {
    var len = str.length,
      tempMask;
    startNum = startNum === undefined ? 3 : startNum;
    endNum = endNum === undefined ? 4 : endNum;
    mask = mask || '****';
    return str.replace(/./g, function (match, index) {
      return index < startNum || index >= len - endNum
        ? match
        : ((tempMask = mask), (mask = ''), tempMask);
    });
  },
  /**
   * 编码Html字符
   * @param html
   * @returns {*}
   */
  htmlEncode: function (html) {
    return document.createElement('div').appendChild(document.createTextNode(html)).parentNode
      .innerHTML;
  },

  /**
   * 解码Html字符
   * @param html
   * @returns {string}
   */
  htmlDecode: function (html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent;
  },

  /**
   * 获得绝对路径，兼容IE下JS跳转不支持base标签的bug
   * @param url
   * @returns {*}
   */
  getAP: function (url) {
    var appPath = window._appPath || '/';
    return /^[^/]/.test(url) && !/(:\/\/)/.test(url)
      ? /\/$/.test(appPath)
        ? appPath + url
        : appPath + '/' + url
      : url;
  },

  /**
   * 重定向页面，兼容IE下JS跳转页面不支持base标签的bug
   * @param url 相对系统根路径
   */
  redirectUrl: function (url) {
    location.href = this.getAP(url);
  },

  /**
   * 替换当前页面，兼容IE下JS跳转页面不支持base标签的bug
   * @param url 相对系统根路径
   */
  replaceUrl: function (url) {
    location.replace(this.getAP(url));
  },

  /**
   * 重新加载页面
   */
  reloadPage: function (force) {
    if (force) {
      var href = window.location.href;
      href += (/\?/.test(href) ? '&' : '?') + '_=' + +new Date();
      window.location.replace(href);
    } else {
      window.location.reload();
    }
  },

  /**
   * 生成随机串
   * @param   {number} len      串长度
   * @param   {string} charSet  自定义串
   * @returns {string} randomString
   */
  randomStr: function (len, charSet) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
      var randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  },

  /**
   * 根据身份证信息判断是否符合年龄区间
   * @param ident 身份证
   * @param ageStart 年龄区间起点 默认：18
   * @param ageEnd 年龄区间终点 默认：22
   * @returns {Boolean}
   */
  isSuitAgeByIdent: function (ident, ageStart, ageEnd) {
    if (!ident) {
      return;
    }
    // 180000 (20180000 - 19990000) 220000 作比较
    ageStart = ageStart || 18;
    ageEnd = ageEnd || 22;
    var identInfo = ident.trim().substr(6, 8);
    var nowInfo = new Date().toJSON().substr(0, 10);
    nowInfo = nowInfo.replace(/-/g, '');
    var numIdentInfo = Number(identInfo);
    var numNowInfo = Number(nowInfo);
    var numAgeStart = Number(ageStart) * 10000;
    var numAgeEnd = Number(ageEnd) * 10000;
    if (numAgeStart < numNowInfo - numIdentInfo && numNowInfo - numIdentInfo < numAgeEnd) {
      return true;
    }
    return false;
  },

  /**
   * 承诺函组件
   * @param ident 身份证号码
   * @param nameInputId 姓名输入框ID
   * @param element append的元素类名
   * @param commaSign 顿号标识，是否需要顿号
   * @param className 承诺函className，添加样式需求
   */
};
const getQueryStringFromUrl = (url, name) => {
  var searchurl = /\?/.test(url) ? url.split('?')[1] : url;
  var search = searchurl.replace('#stay', '');
  var reg = new RegExp('(^|&|#)' + name + '=([^&]*)(&|$)');
  return reg.test(search) ? RegExp.$2 : '';
};

const getQueryString = (name, unescapeable = true) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescapeable ? decodeURIComponent(r[2]) : r[2];
  }
  return '';
};
/**
 * 从当前的query中移除key
 * @param  {...string} keys
 */
const removeQueryByKeys = (...keys) => {
  try {
    const _urlInfo = new URL(location.href);
    keys.forEach((_key) => {
      _urlInfo.searchParams.delete(_key);
    });
    history.replaceState(history.state, '', _urlInfo.toString());
  } catch (error) {
    console.log(error);
  }
};

/*
 * 序列化query参数
 * @param {*} query
 * @returns any
 */
function parseQuery(query = window.location.search) {
  const search = query.split('?')[1] ?? query;
  try {
    return JSON.parse(
      decodeURIComponent(`{"${search.replace(/=/g, '":"').replace(/&/g, '","')}"}`),
    );
  } catch (err) {
    return {};
  }
  // const search = query.split('?')[1] ?? query;
  // const search = query.split('?')[1] ? query.split('?')[1] : query;
  // try {
  //   return JSON.parse(
  //     decodeURIComponent(`{"${search.replace(/=/g, '":"').replace(/&/g, '","')}"}`),
  //   );
  // } catch {
  //   return {};
  // }
}

/**
 * 存储对象
 * @param storage
 * @constructor
 */

const encryFunNew = (data, key) => {
  const encryptStr = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(data),
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );
  return encryptStr.toString();
};

const transPwdEncry = (data, key) => {
  console.log('加密前字符串', data);
  key = key ? key : randomStr(32);
  if (!data) {
    return undefined;
  }
  const resultStr = encryFunNew(data, key);
  console.log('加密后数组', resultStr);
  return {
    encryptedData: resultStr,
    key: key,
  };
  // return str.replace(/\d/g, '*');
  // return undefined;
};

const transPwdDecrypt = (data, key) => {
  console.log('解密前的字符串', data);
  console.log('解密使用的key', key);
  if (!data || !key) {
    return undefined;
  }
  let decrypt = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse('msxfayh@@vayhapi'),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const result = CryptoJS.enc.Utf8.stringify(decrypt).toString();
  return result;
};

/**
 * @param {object} params
 * @returns
 */
const objectToUrlSearchStr = (params) => {
  return new URLSearchParams(params).toString();
};

/**
 * @description 强校验url，追加 /
 * @param {string} params
 * @returns
 */
const checkAndSupplementUrlTail = (url = '') => {
  if (!url?.endsWith('/') || url?.substring(url.length - 1) !== '/') {
    url += '/';
  }
  return url;
};

// 向下取整百
const getFloorHundred = (val) => {
  try {
    if (val) {
      return Math.floor(val / 100) * 100;
    } else {
      return val;
    }
  } catch (e) {
    return val;
  }
};

// 跳转协议展示页统一方法
/**
 * 如需使用，请先在common/domian/protocol/table.ts增加下协议内容
 * protocolName: 在协议实体注册的协议名
 */
const jumpToProtocolPage = (protocolName, params, query) => {
  const host = process.env.NODE_ENV === 'development' ? 'localhost:3010' : location.host;

  let url = `/npublic/page-protocol?protocolName=${protocolName}`;

  // 判断是否携带参数
  if (params) {
    url += '&params=' + encodeURIComponent(JSON.stringify(params));
  }
  // 如果前两个参数都存在，则第三个是query
  if (protocolName && params && query) {
    url += '&queryObj=' + encodeURIComponent(JSON.stringify(query));
  }

  window.location.href = '//' + host + url;
};

// 是否为数字
const isNumber = (val) => typeof val === 'number' && !isNaN(val);

const deepGet = (object, path, defaultValue) => {
  let pathArr = [];
  if (typeof path === 'string') {
    pathArr = path.replace(/\[/g, '.').replace(/\]/g, '').replace(/^\./, '').split('.');
  } else if (Array.isArray(path)) {
    pathArr = [...path];
  }
  return pathArr.reduce((o, k) => (o || {})[k], object) || defaultValue;
};

const getSafeJsonParse = (jsonString, defaultValue = '') => {
  try {
    // 尝试解析 JSON 字符串
    return JSON.parse(jsonString);
  } catch (error) {
    // 如果解析失败，记录错误信息（可选）
    console.error('Failed to parse JSON string:', error);
    // 返回默认值
    return defaultValue;
  }
};

const isOnline = () => {
  return process.env?.IS_PRODUCTION || /(vayh|eapi)\.msxf\.com/.test(location.hostname);
};

const getnewurl = (name) => {
  var loca = window.location;
  var baseUrl = loca.origin + loca.pathname + '?';
  var query = loca.search.substring(1);
  if (query.indexOf(name) > -1) {
    var obj = {};
    var arr = query.split('&');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=');
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    var url =
      baseUrl + JSON.stringify(obj).replace(/["{}]/g, '').replace(/:/g, '=').replace(/,/g, '&');
    return url;
  }
};
/**
 * 千分位
 * @param {*} value     数字
 * @param {*} separator 分隔符，默认逗号
 * @returns
 */
const thousandth = (value, separator = ',', fixedVal = 2) => {
  if (isNaN(value)) return value;
  if (!value) return value;
  value = Number(value).toFixed(fixedVal);
  const values = value.toString().split('.');
  const start = values[0].replace(/(\d)(?=(?:\d{3})+$)/g, `$1${separator}`);
  const end = values.length === 2 ? `.${values[1]}` : '';
  return `${start}${end}`;
};

/**
 * 保留几位小数
 * @param {*} value           值
 * @param {*} fractionDigits  保留位数
 * @returns
 */
const toFixed = (value, fractionDigits = 2) => {
  if (isNaN(value)) return value;
  return Number(value).toFixed(fractionDigits);
};

// 格式化时间
const formatDate = (value, format) => {
  if (!value) return value;
  var t = new Date(value);
  var tf = function (i) {
    return (i < 10 ? '0' : '') + i;
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear());
      case 'MM':
        return tf(t.getMonth() + 1);
      case 'dd':
        return tf(t.getDate());
      case 'HH':
        return tf(t.getHours());
      case 'mm':
        return tf(t.getMinutes());
      case 'ss':
        return tf(t.getSeconds());
    }
  });
};

/**
 * 设置页面标题
 * @returns string
 */
function setPageTitle(title = '') {
  // 全局变量记录页面标题，埋点上报时使用，防止document.title因浏览器渲染导致取值可能存在延迟的问题
  window.__PAGE_TITLE__ = title;
  document.title = window.__PAGE_TITLE__;
}

/**
 * 获得页面标题
 * @returns string
 */
function getPageTitle() {
  return window.__PAGE_TITLE__ || document.title || '';
}

/**
 * sleep 函数
 * @returns promise
 */
function sleep(number = 1000) {
  return new Promise((resolve) => setTimeout(resolve, number));
}

/**
 * 判断时间差是否在范围内，秒单位
 * @returns boolean
 */
function isTimeDifference(startTimestamp, endTimestamp, timeDiff = 3) {
  const diff = (endTimestamp - startTimestamp) / 1000;
  return diff <= timeDiff;
}
export const moneyCount2Decimal = (...args) => {
  return new Decimal(args.reduce((prev, cur) => Decimal.add(prev ?? 0, cur ?? 0))).toFixed(2);
};
/**
 * 检测url是否符合白名单规则
 * @param {*} url
 * @param {*} whiteHosts   白名单列表，支持正则，可选
 * @returns {Boolean} 是否满足白名单
 */
function isWhiteUrl(
  url,
  whiteHosts = [
    '\\.msxfcloud\\.test$',
    '\\.msxfidcsim\\.test$',
    '\\.msxf\\.lotest$',
    '\\.msxfyun\\.test$',
    '\\.msxf\\.local$',
    '\\.msxf\\.com$',
  ],
) {
  if (url) {
    // 自营app外部协议
    if (/^(msxfapp:|ayhshangouh5:)\/\//.test(url)) {
      return true;
    }

    // 解析url
    const urlParseData = String(url).match(/^(http(s)?:)?\/\/([^\\/\\?#]+)/);
    // 判断是否存在hostname，并判断是否是白名单
    if (urlParseData && urlParseData[3]) {
      return new RegExp(`(${whiteHosts.join(')|(')})`).test(urlParseData[3]);
    }
  }
  return false;
}

/**
 * 检测ua中是否包含TEST_HIDE_CONSOLE
 * @returns {Boolean} 是否包含
 */
function isTestHideConsole() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.includes('TEST_HIDE_CONSOLE');
}
/**
 * 解析tcs返回的富文本 TODO p标签暂时删除， br标签删除
 * @param input
 * @returns
 */
export const parseString = (input) => {
  const regex = /(<(\w+)([^>]*)>(.*?)<\/\2>)|([^<]+)/g;
  const result = [];
  let match = null;
  const newIput = input.replaceAll('<p>', '').replaceAll('</p>', '');
  while ((match = regex.exec(newIput)) !== null) {
    if (match[1]) {
      // 处理带标签的内容
      const styleMatch = /style="([^"]*)"/.exec(match[3]);
      const style = styleMatch
        ? Object.fromEntries(
            styleMatch[1]
              .split(';')
              .filter((s) => s.trim())
              .map((s) => {
                const [key, value] = s.split(':').map((str) => str.trim());
                return [key, value];
              }),
          )
        : undefined;
      result.push({
        text: match[4].replaceAll('<br>', ''),
        style,
      });
    } else if (match[5]) {
      // 处理纯文本内容
      result.push({
        text: match[5].trim(),
        style: undefined,
      });
    }
  }

  return result;
};
// 邮箱校验
const validateEmail = function (email) {
  // 邮箱正则表达式
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // 检查邮箱是否为空
  if (!email || email.trim() === '') {
    return false;
  }

  // 使用正则表达式测试邮箱格式
  return emailRegex.test(email);
};

const getTipsAb = async () => {
  let abResult = 'A';
  try {
    if (curEnv.isAPP) {
      abResult = await getABOnline({ key: 'Contactwenan', default_value: 'C' });
    }
    return abResult;
  } catch (e) {
    return abResult;
  }
};

const isLocal = () => {
  if (location.hostname === 'localhost') return true;
  if (location.hostname === '127.0.0.1') return true;
  if (location.hostname.includes('msxf') && location.hostname.includes('test')) return true;
  return false;
};

export {
  isLocal,
  isNumber,
  jumpToProtocolPage,
  getQueryStringFromUrl, // 从传入的url 中获取参数
  getQueryString, // 获取url参数
  parseQuery,
  debounce, // 防抖
  encodeName, //加密名字
  encodePhone, //加密手机号  加密中间四位
  maskPhone, // 加密手机号  保留后三位
  encodeIdCard, //加密身份证号
  checkZhName, //名字校验
  checkPhone, //手机号校验
  checkBankID, //银行卡号
  checkIDNumber, //身份证号
  filterProtocol,
  AES,
  cbcAesDecip,
  getUrlKey,
  getUrlToJson,
  checkLoginPwd, //登录密码校验
  checkSafeLoginPwd, //登录密码安全校验
  checkBankIdSimple, //
  isEmpty, //为空
  isNotEmpty, //不为空
  smsCode, //验证码规则校验
  compile, // 普通加密
  uncompile, // 普通解密
  // getAndroidVersion, //获取安卓版本号
  randomStr, //获取随机数
  clientType, //浏览器类型
  numToChina, //数字转汉字
  IS_ALIFACE_CLIENT,
  aliAppVersion,
  alipayJSBridgeReady,
  justRequest,
  isAyhSelfProductCode,
  getCurrentDate, // 获取当天时间
  isJsonString,
  isObject,
  isTqV2,
  formatAdpAllData,
  formatFirstIndexAdpData,
  CommonUtil,
  transPwdEncry,
  transPwdDecrypt,
  objectToUrlSearchStr,
  checkAndSupplementUrlTail,
  getFloorHundred,
  getdate,
  deepMerge,
  removeQueryByKeys,
  sleep,
  isTimeDifference,
  deepGet,
  isOnline,
  getnewurl,
  thousandth,
  toFixed,
  formatDate,
  setPageTitle,
  getPageTitle,
  isWhiteUrl,
  encodSurname,
  getSafeJsonParse,
  isTestHideConsole,
  validateEmail,
  getTipsAb,
};
